export const activeCommitHash = '560873e09b7207c8323b2fea1c909ccefb8303b2'
